// src/pages/AdminPanel.js

import React, { useContext } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { AuthContext } from "../utils/AuthContext";
import logo from "../assets/images/NZ-Pure-Dairy-Logo.svg";


import "../styles/AdminPanel.css";
import "../styles/Forms.css";
import "../styles/Buttons.css";
import "../styles/Batches.css";
import "../styles/SearchBar.css";
import "../styles/Pagination.css";
import "../styles/Responsive.css";


import ViewBatches from "./ViewBatches";
import AddBatch from "./AddBatch";
import EditBatch from "./EditBatch";
import AddProduct from "./AddProduct";
import ViewProducts from "./ViewProducts";
import EditProduct from "./EditProduct";

const AdminPanel = () => {
  const { handleLogin } = useContext(AuthContext);
  const navigate = useNavigate();


  const logout = () => {
    handleLogin(false);
    navigate("/admin/login"); 
  };

  return (
    <div className="admin-panel">
   
      <Sidebar />

  
      <div className="admin-content">
     
        <div className="admin-header">
          <div className="admin-title-container">
            <img src={logo} alt="NZ Pure Dairy Logo" className="admin-logo" />
            <h1 className="admin-title">
              NZ Pure Dairy QR Code Traceability System
            </h1>
          </div>
          <button onClick={logout} className="logout-button">
            Logout
          </button>
        </div>

        <Routes>
          <Route index element={<ViewBatches />} />

       
          <Route path="batches" element={<ViewBatches />} />
          <Route path="add-batch" element={<AddBatch />} />
          <Route path="edit-batch/:batchNo" element={<EditBatch />} />

          <Route path="products" element={<ViewProducts />} />
          <Route path="add-product" element={<AddProduct />} />
          <Route path="edit-product/:productCode" element={<EditProduct />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminPanel;
